import styled, { css } from 'styled-components';
import * as Styles from '../../utils/styleUtils';

export const StepperWrapper = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  padding: 0;
  overflow: hidden;

  ${Styles.FontStyles}
  ${Styles.BorderStyles}

  height: ${({ renderMode, height }) => (renderMode === 'preview' ? height : 'auto')};
`;

export const ValueDisplay = styled.span`
  flex-grow: 1;
  padding: 2px 5px;
  text-align: ${({ styleProps }) => styleProps?.textAlign || 'left'};
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-left: 1px solid #ccc;
  width: 32px;
  flex-shrink: 0;
  background-color: #F6f6f6;
`;

export const StepperButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  cursor: pointer;

  &:hover {
    background-color: #e9e9e9;
  }
`;

export const StepperArrow = styled.span`
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #777;

  /* Point the arrow down by rotating it */
  ${({ direction }) => direction === 'down' && css`
    transform: rotate(180deg);
  `}
`;